import { useSelector } from 'react-redux'

import {
  Branding,
  Config,
  Content,
  LocalisedContent,
  StepConfig,
} from '@/types/partnerConfig'
import { ReduxState } from '@/config/redux/types'

const selectBranding = (state: ReduxState): Branding =>
  state.partnerConfig.branding

const selectConfig = (state: ReduxState): Config => state.partnerConfig.config
const selectSteps = (state: ReduxState): StepConfig[] =>
  selectConfig(state).steps
const selectPartnerDefaultLanguage = (
  state: ReduxState
): Config['acceptLanguage'] => selectConfig(state).acceptLanguage

const selectContent = (state: ReduxState): Content =>
  state.partnerConfig.content

const selectLocalisedContent = (locale: string) => (
  state: ReduxState
): LocalisedContent => selectContent(state)[locale]

const selectPartnerId = (state: ReduxState) =>
  state.partnerConfig.config.id || 'babylon-health'

const selectAppName = (state: ReduxState) => selectConfig(state)?.appName

const useBranding = () => useSelector(selectBranding)
const useConfig = () => useSelector(selectConfig)
const useContent = () => useSelector(selectContent)
const usePageContent = () => useSelector(selectContent)
const useLocalisedContent = (locale: string) =>
  useSelector(selectLocalisedContent(locale))
const usePartnerId = () => useSelector(selectPartnerId)
const useAppName = () => useSelector(selectAppName)

export {
  useBranding,
  useConfig,
  useContent,
  usePageContent,
  useLocalisedContent,
  usePartnerId,
  useAppName,
  selectBranding,
  selectConfig,
  selectContent,
  selectSteps,
  selectPartnerDefaultLanguage,
  selectPartnerId,
  selectAppName,
}
